import { render, staticRenderFns } from "./RequestQuotation.vue?vue&type=template&id=f8b8828e&scoped=true&"
import script from "./RequestQuotation.vue?vue&type=script&lang=js&"
export * from "./RequestQuotation.vue?vue&type=script&lang=js&"
import style0 from "./RequestQuotation.vue?vue&type=style&index=0&id=f8b8828e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b8828e",
  null
  
)

export default component.exports